import script from "./PMPStep2Produccion.vue?vue&type=script&setup=true&lang=js"
export * from "./PMPStep2Produccion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__